import {Component, OnInit} from '@angular/core';
import {ProcampoService} from "../../../../services/procampo.service";
import {ToastService} from "../../../../services/toast.service";
import {ProCampo} from "../../../../types/ProCampo.type";
import {ProareaService} from "../../../../services/proarea.service";
import {ConfirmationService} from "primeng/api";

interface TipoDado {
  value: string;
  label: string;
}

@Component({
  selector: 'app-campo',
  templateUrl: './procampo.component.html',
  styleUrl: './procampo.component.css',
  providers: [ConfirmationService]
})
export class ProCampoComponent implements OnInit {

  formDialog: boolean = false;
  campoDialog!: ProCampo
  formEnviado: boolean = false;

  tipoDados: TipoDado[] = [];

  selecionarVariaveis: any[] = []

  campos: ProCampo[] = []
  camposClonados: {[s: string]: ProCampo } = {}

  constructor(private proCampoService: ProcampoService, private toastService: ToastService, private proAreaService: ProareaService, private confirmationService: ConfirmationService) {}

  ngOnInit() {

    this.tipoDados = [
      {label: 'TEXTO', value: 'TEXTO'},
      {label: 'NUMERO', value: 'NUMERO'},
      {label: 'DATA', value: 'DATA'},
    ]

    this.proAreaService.getAreaComVariaveis().subscribe({
      next: data => {
        this.selecionarVariaveis = data;
      },
      error: err => {
        this.toastService.erro("Erro", "Erro ao buscar as variaveis")
      }
    })

    this.carregaCampos();
  }

  carregaCampos(){
    this.proCampoService.getCampos().subscribe({
      next: data => {
        this.campos = data;
      },
      error: err => {
        this.toastService.erro("Erro", err.message);
      }
    })
  }

  editarLinha(campo: ProCampo) {
    this.camposClonados[campo.id as string] = { ...campo };
  }

  salvarLinha(campo: ProCampo) {

    this.formEnviado = true;

    let campoEnviar = {
      id: campo?.id,
      campo: campo.campo,
      nome: campo.nome,
      tipo: campo.tipo,
      tipoIntegracao: campo.tipoIntegracao,
      sistemaOrigem: campo.sistemaOrigem,
      dataLan: campo.dataLan,
      idVariavel: campo.variavel?.id
    }

    if(campoEnviar.nome == undefined || campoEnviar.campo == undefined) return;

    if(campoEnviar.nome?.trim?.()?.length == 0) return;
    if(campoEnviar.campo == null || campoEnviar.campo?.trim?.()?.length == 0) return;



    if(campo.id != null){
      this.proCampoService.putCampo(campoEnviar).subscribe({
        next: data => {
          this.toastService.sucesso("Atualizado", "Campo atualizado com sucesso!")
        },
        error: err => {
          this.toastService.erro("Erro", err.error.message);
        },
        complete: () => {
          this.formEnviado = false;
          this.esconderDialogo()
          this.carregaCampos();
        }
      })
    }else{
      this.proCampoService.postCampo(campoEnviar).subscribe({
        next: data => {
          this.toastService.sucesso("Sucesso", "Campo criaoo com sucesso!")
        },
        error: err => {
          this.toastService.erro("Erro", err.error.message);
        },
        complete: () => {
          this.formEnviado = false;
          this.esconderDialogo()
          this.carregaCampos();
        }
      })
    }
  }

  cancelar(campo: ProCampo, index: number) {
    this.campos[index] = this.camposClonados[campo.id as string];
    delete this.camposClonados[campo.id as string];
  }

  formatarLabelVariaveis = (item: any): string => {
    console.log(item);
    return `${item.codigo} - ${item.descricao}`;
  }

  esconderDialogo(){
    this.formDialog = false;
  }

  abrirDialogo(){
    this.formDialog = true;
    this.campoDialog = { tipoIntegracao: this.tipoDados[0].value, tipo: this.tipoDados[0].value};
    this.formEnviado = false;
  }

  excluirCampo(campo: ProCampo) {

    if(campo.id == null) return;

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o campo ' + campo.nome + '?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        if(campo.id != null) {
          this.proCampoService.deletecampo(campo.id).subscribe({
            next: data => {
              this.toastService.sucesso("Sucesso", "Campo excluído com sucesso")
            },
            error: err => {
              this.toastService.erro("Erro", err.error.message);
            },
            complete: () => {
              this.carregaCampos();
            }
          })
        }
      }
    });
  }

  trocaData(campo: ProCampo) {


    this.proCampoService.existeCampoDataAtivo().subscribe({
      next: data => {
        this.confirmationService.confirm({
          message: 'Existe outro campo já selecionado. Deseja trocar para ' + campo.nome + '?',
          header: 'Confirmação',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          accept: () => {
            if(campo.id != null) {
              this.ativarCampo(campo.id)
            }
          },
          reject: () => {
            campo.dataLan = false
          }
        });
      },
      error: err => {
        if(campo.id != null) {
          this.ativarCampo(campo.id)
        }
      }
    })

  }


  ativarCampo(id: string){
    this.proCampoService.ativarCampoData(id).subscribe({
      next: data => {
        this.toastService.sucesso("Sucesso", "Campo ajustado")
      },
      error: err => {
        this.toastService.erro("Erro", err.error.message);
      },
      complete: () => {
        this.carregaCampos();
      }
    })
  }

}
